import styled from "styled-components";

import breakpoints from "../../styles/breakpoints";
import { header } from "../../styles/variables";

import { Section } from "../../components/atoms/Section";
import { Container } from "../../components/atoms/Container";
import Link from "../../components/atoms/LinkWineScreen";

export const WinesSection = styled(Section)`
  padding-top: 0px !important;
`;

export const ContainerTop = styled.div`
  width: 100%;
  display: flex;
  padding-right: 20px;
  justify-content: space-between;
  ${breakpoints.smDown} {
    flex-direction: column;
    padding-right: 0;
  }
`;

export const OptionsButtons = styled.div`
  display: flex;
  align-items: center;
  height: 50px;
  width: 50%;

  ${breakpoints.smDown} {
    justify-content: center;
    height: 100%;
    width: 100%;
    padding-right: 25px;
  }
`;

export const OptionButton = styled(Link)`
  width: 50%;
  ${breakpoints.smDown} {
    width: 60%;
    flex-direction: column;
  }
`;

export const HeroContainer = styled(Container)`
  padding-right: 20px;
`;

export const SelectorsHolder = styled.div`
  display: flex;
  justify-content: space-between;
  width: 50%;
  ${breakpoints.smDown} {
    display: none;
  }
`;

export const SelectDropdownHolder = styled.div`
  width: 48%;
  max-width: 300px;
  ${breakpoints.smDown} {
    width: 100%;
    max-width: none;
  }
  ${breakpoints.mdDown} {
    p {
      font-size: 11px;
    }
  }
`;

export const SmUpSearchContainer = styled.div`
  ${breakpoints.smDown} {
    display: none;
  }
`;

export const OptionsAndSearchFilterContainer = styled.div`
  position: static;
  padding-top: 15px !important;

  ${breakpoints.smDown} {
    position: sticky;
    z-index: 199;
    top: ${(props) =>
      props.hasCartOnTop
        ? header.withBoxAndCartTrayMobileHeight // [DEV-3051] Update when deprecating toggle feature flag.
        : header.mobileHeight};
    background-color: white;
    display: ${(props) => (props.isShown ? "block" : "none")};
  }
`;
